import axios from "axios";

async function perdaAutorizacao() {
  alert("Por favor, faça login novamente!");
  window.location.href = "app/login";
}

export function retornaUsuario(login) {
  let usuarioLogadoStorage = {};
  if (!login && !usuarioLogadoStorage) {
    perdaAutorizacao();
    return;
  }
  return usuarioLogadoStorage;
}

function retornaHeaders() {
  let usuarioLogado = {};
  try {
    const dadosUsuario = sessionStorage.getItem("dadosUsuarioLogado");
    if (!dadosUsuario || dadosUsuario === "null") {
      usuarioLogado = {};
    } else {
      usuarioLogado = JSON.parse(dadosUsuario);
    }
  } catch (e) {}
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (usuarioLogado.userToken || ""),
    },
  };
}

export function retornaUrlBase() {
  if (ehHomologacao()) {
    return "https://homologacao.quitaboletos.com/";
  }
  if (ehProducao()) {
    return "https://api.quitaboletos.com/";
  }
  return "http://localhost:21092/";
}

function retornaUrlServer() {
  let url = retornaUrlBase();
  return url + "internal-client/";
}
export function ehLocal() {
  const url = retornaUrlServer();
  return url.indexOf("localhost") !== -1;
}

export function ehHomologacao() {
  return process.env.REACT_APP_ENVIRONMENT === "HOMOLOG";
}

export function ehProducao() {
  return process.env.NODE_ENV === "production";
}

export function post(endpoint, body) {
  var promise = new Promise((resolve, reject) => {
    if (!body) {
      body = {};
    }
    axios
      .post(retornaUrlServer() + endpoint, body, retornaHeaders())
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        trataErro(error, reject);
      });
  });
  return promise;
}
const trataErro = (error, reject) => {
  if (error.response && error.response.status === 401) {
    perdaAutorizacao();
    return;
  }
  reject(error);
};
export function get(endpoint) {
  var promise = new Promise((resolve, reject) => {
    axios
      .get(retornaUrlServer() + endpoint, retornaHeaders())
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        trataErro(error, reject);
      });
  });
  return promise;
}

export function remove(endpoint) {
  var promise = new Promise((resolve, reject) => {
    axios
      .delete(retornaUrlServer() + endpoint, retornaHeaders())
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        trataErro(error, reject);
      });
  });
  return promise;
}
